<template>
  <div class="single-author">
    <div class="author-name" v-if="item.name != ''"><span :class="{'deceased' : item.deceased}">{{ item.name }}</span></div>
    <div class="author-name" v-if="item.collab != ''">{{ item.collab }}</div>
    <div class="author-content">
      <p v-if="item.orcid"><span>ORCID：</span><a :href="item.orcid" target="_blank">{{item.orcid}}</a></p>
      <div v-if="item.aff">
        <p v-if="item.aff.length==1"><span>机 构：</span>{{item.aff[0].text}}</p>
        <div v-else-if="item.aff.length>1" class="affs" style="display: flex;">
          <p><span><nobr>机 构：</nobr></span></p>
          <div><p v-for="affItem in item.aff">{{affItem.label ? affItem.label + '. ' + affItem.text : affItem.text}}</p>
          </div>
        </div>
      </div>
      <div>
        <p v-if="item.affEn.length == 1"><span>Affiliation：</span>{{ item.affEn[0].text }}</p>
        <div v-else-if="item.affEn.length>1" class="affs" style="display: flex;">
          <p><span>Affiliation：</span></p>
          <div><p v-for="affItem in item.affEn">
            {{affItem.label ? affItem.label + '. ' + affItem.text : affItem.text}}</p></div>
        </div>
      </div>
      <p v-if="item.noInfo && ARTICLE.defaultlang=='zh' && item.name !='' && role == undefined">暂无本作者相关信息</p>
      <p v-if="item.noInfo && ARTICLE.defaultlang=='en' && item.name !='' && role == undefined">no detail information about the author</p>
      <p v-if="item.collab !='' && ARTICLE.defaultlang=='zh'">该作者为机构作者</p>
      <p v-if="item.collab !='' && ARTICLE.defaultlang=='en'">This is an institutional author</p>

      <p v-if="item.isFirstAuthor">
        <span>{{lang == 'en' ? 'Role: ' : '角 色：'}}</span>{{lang == 'en' ? 'First author' : '第一作者'}}</p>
      <p v-if="item.corresp">
        <span>{{lang == 'en' ? 'Role: ' : '角 色：'}}</span>{{lang == 'en' ? 'Corresponding author' : '通信作者'}}</p>
      <p v-if="item.equal">
        <span>{{lang == 'en' ? 'Role: ' : '角 色：'}}</span>{{lang == 'en' ? 'Contribute equally' : '同等贡献者'}}</p>
      <p v-if="role"><span>{{lang == 'en' ? 'Role: ' : '角 色：'}}</span>{{lang == 'en' ? role.en : role.zh}}</p>
      <p v-if="item.phone != '' && item.phone != null">
        <span>{{lang == 'en' ? 'Telephone: ' : '电 话：'}}</span>{{ item.phone }}</p>
      <p v-if="item.email != '' && item.email != null"><span>{{lang == 'en' ? 'Email: ' : '邮 箱：'}}</span><a
        :href="'mailto:'+item.email">{{ item.email
        }}</a></p>
      <div v-if="item.bio.length > 0">
        <p v-for="bioItem in item.bio"><span>{{bioItem.lang == 'en' ? 'Profile: ' : '作者简介：'}}</span>
          <span style="display: block"><img v-for="item1 in bioItem.graphic" :src="item1.big"
                                            v-if="item1.big && item1.big != ''"
                                            style="width: 100px;height: auto;"/></span>
          <span class="text" v-for="(item1,index1) in bioItem.data" :key="'bio'+index + index1">
              <component :is="'jo' + item2.name" v-for="item2 in item1" v-bind:key="item2.index"
                         v-bind:data="item2.data"></component>&nbsp;</span></p>
      </div>
      <p v-else-if="item.profile.length>0" v-for="(note,index) in item.profile"><span
        v-if="note">{{index == 0 ? '作者简介：' : 'Profile：'}}</span>{{ note }}</p>
      <div v-else-if="item.supervisor.length>0">
        <p v-for="(item1,index) in item.supervisor" v-if="item1 != ''">
          <span>{{index == 0 ? '导师简介：' : 'Tutor: '}}</span>{{ item1 }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        lang: this.ARTICLE.defaultlang !== '' ? this.ARTICLE.defaultlang : 'zh'
      }
    },
    props: [
      'item',
      'role'
    ],
  }
</script>

<style lang="scss" scoped>
  .single-author {
    .author-name {
      margin-top: 12px;
      font-size: 1.8rem;
      margin-bottom: 1rem;
      color: #333;
      letter-spacing: 0.03em;
    }
    .deceased {
      border: 1px solid #000000;
    }
    .author-content {
      margin: 0 0 40px 20px;
      font-size: 1.3rem;
      p {
        span {
          font-weight: bold;
        }
        span.text {
          font-weight: normal;
        }
        a {
          color: #00a2af;
        }
        img {
          width: 100px;
          height: auto;
        }
      }
      .affs {
        & > p {
          display: inline-block;
          vertical-align: top;
        }
        div {
          display: inline-block;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/author/authorItem.vue